module.exports = __webpack_public_path__ + "img/cdci.2fc6350d.svg";